import {observer} from "mobx-react";
import {PaperBlock} from "../../components/paperBlock";
import style from "./style.module.sass"
import {Trans, useTranslation} from "react-i18next";
import TitleList from "../../components/titles/titleList";
import {useEffect} from "react";
import {useStores} from "../../hooks";
import SmallGreyText from "../../components/titles/SmallGreyTitle";
import {Loader} from "../../components/loader";
import {useHistory, useParams} from "react-router-dom";
import {Order, PaymentProviderType} from "../../services/order/models";
import {FadeInOutVertical} from "../../components/Animated";


const OrderPaymentCheck = () => {
    const { ordersStore, generalStore, checkoutStore } = useStores();
    const history = useHistory();

    const { t } = useTranslation(['viewOrder', 'cart'])
    const params = useParams<{ orderId: string, orgId: string, branchId: string, menuId: string }>();
    const currentOrder: Order | undefined = ordersStore.currentOrder;


    useEffect(() => {
        (async () => {
            if (!currentOrder || currentOrder.id !== parseInt(params.orderId)) {

                await ordersStore.setCurrentOrder(parseInt(params.orderId));

                const order = currentOrder;


                if (order && generalStore.organizationId === -1) {
                    await generalStore.init({
                        organizationId: parseInt(params.orgId),
                        organizationBranchId: parseInt(params.branchId),
                        menuId: parseInt(params.menuId),
                        tableId: "0",
                        pointId: "",
                        viewOnly: false,
                        isWidget: false
                    })
                }
            }
        })()
    }, [ordersStore.currentOrder, ordersStore, params]);

    useEffect(() => {
        const timer = setInterval(() => {
            ordersStore.reloadCurrentOrder();
        }, 5000)
        return () => {
            clearInterval(timer);
        }
    }, [ordersStore.currentOrder?.paymentDetails])
    useEffect(() => {
        if (currentOrder && currentOrder.paymentDetails?.type === PaymentProviderType.sbpTochka &&
            currentOrder.paymentDetails.isPaid && checkoutStore.deliveryDetails !== null) {
            ordersStore.addOrder({
                ...currentOrder,
                deliveryDetails: checkoutStore.deliveryDetails,
                clientId: checkoutStore.clientId,
            });
        }

    }, [ordersStore.currentOrder?.paymentDetails])

    if (!currentOrder) {
        return <div style={{
            height: "100vh",
            width: "100vw",
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            maxWidth: 500
        }}>
            <Loader/>
        </div>
    }

    return (

        <div className={style.container}>
            <FadeInOutVertical>
                <PaperBlock>
                    <div className={style.title}>
                        <TitleList>
                            <Trans i18nKey="viewOrder:order" values={{ orderId: currentOrder.id }}/>
                        </TitleList>
                        <SmallGreyText>
                            {t("cart:waiting")}
                        </SmallGreyText>
                        {(currentOrder.paymentDetails?.type === PaymentProviderType.sbpTochka && currentOrder.paymentDetails.isPaid) &&
                            history.push(`/order/${generalStore.organizationId}/${generalStore.organizationBranchId}/${generalStore.menuId}/${currentOrder.id}/view`)
                        }
                        {currentOrder.paymentDetails?.type === PaymentProviderType.sbpTochka && !currentOrder.paymentDetails.isPaid &&
                            <Loader/>
                        }
                        <div className={style.button}
                             onClick={() => {
                                 if (currentOrder && currentOrder.paymentDetails?.type === PaymentProviderType.sbpTochka)
                                     window.open(currentOrder.paymentDetails.qrCodeLink)
                             }}>
                            {t("cart:bankApp")}
                        </div>
                        <div className={style.buttonToCart}
                             onClick={() => {
                                 history.goBack()
                             }
                             }>
                            {t("cart:otherPayment")}
                        </div>
                    </div>
                </PaperBlock>
            </FadeInOutVertical>
        </div>

    )
};

export default observer(OrderPaymentCheck);
